export class Speciality {
  _id: string;
  name: string;
}
